import React from "react";

/* ============================================================================
 * HomeCategories — แถวไอคอนทางลัดค้นหา (คั่นระหว่างกล่องค้นหากับแบนเนอร์)
 *
 * เป็นทางลัดไปยังผลค้นหาที่คนกดบ่อย ไม่ต้องไปเลือกทีละช่องในกล่องค้นหา
 * รายการ/ไอคอน/ลำดับ ผู้ดูแลแก้ได้จากหลังบ้าน (section "shortcut")
 * link_url เก็บเงื่อนไขแบบ query string เช่น listing_type=เช่า
 * ========================================================================== */
export default function HomeCategories({ items = [], onSelect }) {
    if (!items.length) return null;

    return (
        <div className="hm-container">
            <div className="hm-cats">
                {items.map((item) => (
                    <button key={item.uid} type="button" className="hm-cat" onClick={() => onSelect && onSelect(item)}>
                        <span className="hm-cat__icon hm-ico">{item.icon}</span>
                        <span className="hm-cat__label">{item.title}</span>
                    </button>
                ))}
            </div>
        </div>
    );
}
